export enum PackState {
  IDLE = 'IDLE',
  HOVER = 'HOVER',
  RIP = 'RIP',
  FLASH = 'FLASH',
  REVEAL = 'REVEAL',
  DONE = 'DONE'
}

export interface PackAnimationConfig {
  state: PackState
  progress: number
  isHovering: boolean
  mouseX: number
  mouseY: number
  packTexture: string
  onStateChange?: (state: PackState) => void
  onComplete?: () => void
}

export interface Particle {
  position: { x: number; y: number; z: number }
  velocity: { x: number; y: number; z: number }
  size: number
  opacity: number
  life: number
  maxLife: number
  color: number
}

export interface LightConfig {
  intensity: number
  color: number
  decay: number
  distance: number
}
